package org.zq.astrock_ai.quant

internal object Indicators {
    fun sma(closes: List<Double>, period: Int): List<Double?> {
        if (period <= 0) return closes.map { null }
        val out = MutableList<Double?>(closes.size) { null }
        var sum = 0.0
        for (i in closes.indices) {
            sum += closes[i]
            if (i >= period) sum -= closes[i - period]
            if (i >= period - 1) out[i] = sum / period
        }
        return out
    }

    fun highest(values: List<Double>, period: Int, endIndex: Int): Double {
        val from = (endIndex - period + 1).coerceAtLeast(0)
        var max = values[from]
        for (i in (from + 1)..endIndex) {
            if (values[i] > max) max = values[i]
        }
        return max
    }

    fun lowest(values: List<Double>, period: Int, endIndex: Int): Double {
        val from = (endIndex - period + 1).coerceAtLeast(0)
        var min = values[from]
        for (i in (from + 1)..endIndex) {
            if (values[i] < min) min = values[i]
        }
        return min
    }

    /** Wilder RSI；前 period 根为 null。 */
    fun rsi(closes: List<Double>, period: Int = 14): List<Double?> {
        if (period <= 0 || closes.size <= period) return closes.map { null }
        val out = MutableList<Double?>(closes.size) { null }
        var avgGain = 0.0
        var avgLoss = 0.0
        for (i in 1..period) {
            val d = closes[i] - closes[i - 1]
            if (d >= 0) avgGain += d else avgLoss -= d
        }
        avgGain /= period
        avgLoss /= period
        fun value(g: Double, l: Double): Double {
            if (l <= 1e-12) return 100.0
            val rs = g / l
            return 100.0 - 100.0 / (1.0 + rs)
        }
        out[period] = value(avgGain, avgLoss)
        for (i in (period + 1) until closes.size) {
            val d = closes[i] - closes[i - 1]
            val gain = if (d > 0) d else 0.0
            val loss = if (d < 0) -d else 0.0
            avgGain = (avgGain * (period - 1) + gain) / period
            avgLoss = (avgLoss * (period - 1) + loss) / period
            out[i] = value(avgGain, avgLoss)
        }
        return out
    }
}
